import theme from '../../../lib/theme';
import { ArticleTileBlockProps, ArticleTileConfig } from './ArticleTileBlock';
const {
	layouts,
	colors,
	scale,
	media,
	font: { families, heights, spacings, ...font },
} = theme;

const defaultGap = scale.xxxxs;

export default ({
	// title,
	// columns,
}: ArticleTileBlockProps) => ({
	//#region Article Tile Block Styles
	articleTileBlock: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		gap: scale.xxxxs,

		'&.sidebar-posts .article-tile-content *, &.trending-posts .article-tile-content *': {
			fontSize: '12px!important',
		},
	},
	articleTileBlockGrid: {
		display: 'flex',
		gap: scale.xxxxs,

		[media.l.down]: {
			flexDirection: 'column',
			gap: defaultGap,
			width: '100%!important',
		},
	},

	articleTileBlockGridColumn: {
		display: 'flex',
		flexWrap: 'wrap',
		flexGrow: 1,
		gap: scale.xxxxs,

		[media.l.down]: {
			gap: scale.xxxxs,
			width: '100%!important',
			maxWidth: '100%!important',
		},

		'&.show-no-meta .article-tile-content-meta .article-tile-author': {
			display: 'none!important',
		},

		'.column-nav-link': {
			alignItems: 'center',
			display: 'flex!important',
			width: '100%',
			justifyContent: 'flex-end',
			borderBottom: '1px solid #b898ff',

			'>a': {
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'flex-end',
				gap: '0.25em',
				backgroundColor: '#b898ff',
				padding: '0.25em 1em',
				color: '#fff',
				fontSize: '0.8em',
				textDecoration: 'none',
				transition: 'text-decoration 0.3s ease',
			},
		},
	},
	//#endregion Article Tile Block Styles

	//#region Article Tile Item Styles
	articleTileLink: {
		display: 'flex',
		textDecoration: 'none',
		transition: 'color 0.3s ease',
		color: '#333',

		'&:hover': {
			textDecoration: 'none',
			color: '#b898ff',

			'.article-tile-content-meta .article-tile-author': {
				color: '#fff!important',
			},
			'.article-tile-content-meta .article-tile-post_date': {
				color: '#333!important',
			},
		},

		'&.is-cover-image .article-tile-content:after': {
			content: '""',
			position: 'absolute',
			top: '-100px',
			left: 0,
			right: 0,
			bottom: 0,
			background: `linear-gradient(to top, rgba(255, 255, 255, 0.9) 30%, rgba(255, 255, 255, 0))`,
			zIndex: 0,
		},

		'&.use-grid-on-resize': {
			[media.l.down]: {	// Use grid on tablet view - restore for mobile below
				maxWidth: '50%!important',
				width: 'calc(50% - 0.5em)!important',
				flex: '1 0 calc(50% - 0.5em)!important',
			},
			[media.m.down]: {
				maxWidth: '100%!important',
				width: 'calc(100% - 0.5em)!important',
				flex: '1 0 calc(100% - 0.5em)!important',
			},
		},
	},

	navSectionLinksItems: {

		[media.xl.down]: {
			display: `none!important`,
		}
	},

	articleTileWrap: {
		display: 'flex',
		gap: `calc(${defaultGap}*2)`,
		width: '100%',
	},
	articleTileImageWrap: {

	},
	articleTileImage: {
		width: '100%',
		height: 'auto',
	},
	articleTileContent: {
		fontSize: '14px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'flex-start',
		zIndex: 1,
		transition: 'all 0.3s ease',
		position: 'relative',
	},
	articleTileContentTitle: {
		fontSize: '16px',
		zIndex: 1,
	},
	articleTileContentMeta: {
		display: 'flex',
		alignItems: 'center',
		gap: '1em',
		zIndex: 1,
	},
	articleTileAuthor: {
		padding: '0.25em 1em',
		backgroundColor: '#b898ff',
		color: '#fff',
		fontSize: '12px',
		margin: '0',
	},
	articleTilePostDate: {
		fontSize: '11px',
		color: '#666',
		margin: '0',
	},
	navSectionLinks: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: '2em',
		borderBottom: '2px solid #651fff',

		'h2': {
			backgroundColor: '#651fff',
			padding: '0.25em 1em',
			color: '#fff',
			fontSize: '1.2em',
			margin: '0!important',
		},
		'h2>a': {
			color: '#fff',
		},

		'&.alt-color': {
			borderBottom: '2px solid #b898ff',
			'h2': {
				backgroundColor: '#b898ff',
			},
		},
		'&.alt-size-small': {
			'h2': {
				fontSize: '1em',
				padding: '0.5em 1em 0.4em 1em',	// compsensate for smaller font size
			}
		},
		
		'.nav-section-links-items': {
			display: 'flex',
			justifyContent: 'flex-start',
			flexWrap: 'nowrap',
			flexGrow: 1,
			gap: '2em',
		},
		'.nav-link': {
			padding: 0,
			fontSize: '0.9em',
			color: '#651fff',
			fontWeight: 400,
		}
	},

	moreMenuContainer: {
		display: 'flex',
		position: 'relative',
		justifyItems: 'flex-end',

		'&:hover .overflow-menu': {
			display: 'flex',
			gap: '0.25em',
			flexDirection: 'column',
		},

		'.nav-link.more-link': {
			cursor: 'pointer',
		},

		'.overflow-menu': {
			display: 'none',
			position: 'absolute',
			top: '100%',
			right: 0,
			backgroundColor: 'white',
			border: '1px solid #e5e7eb',
			boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
			zIndex: 100,
			minWidth: '250px',
			padding: '1em',
		},

		'.overflow-menu .nav-link': {
			display: 'block',
			width: '100%',
			boxSizing: 'border-box',
			whiteSpace: 'normal',
		},
	},
	//#endregion Article Tile Item Styles
});